/// <reference types="@emotion/react/types/css-prop" />
import tz from 'moment-timezone'
import React from 'react'
import ReactDOM from 'react-dom'
import Modal from 'react-modal'
import 'url-search-params-polyfill'

import Root from 'Root'
import { initSentry } from 'utils/sentry'

tz()

initSentry()

const rootEl = document.getElementById('root')

Modal.setAppElement(rootEl)
Modal.defaultStyles.content = null
Modal.defaultStyles.overlay = null

ReactDOM.render(<Root />, rootEl)
